const React = require('react')
const { useHistory, useParams } = require('react-router-dom')
const { UncontrolledTooltip } = require('reactstrap')
const { useFormatBytes } = require('@hooks')
const { useNetworkConfig } = require('@contexts')

const { CopyButton } = require('@components/copyButton')

require('@styles/pages/token/index.css')

const TokenInventoryTable = props => {
    const { data, setActiveTab } = props
    const { address } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()
    const formatBytes = useFormatBytes()

    return (
        <div className='nft-block-wrapper'>
            {data?.map((item, index) => (
                <div className='nft-block' key={index}>
                    <img
                        className='nft-block-img'
                        src={item.image || 'https://etherscan.io/images/main/nft-placeholder.svg'}
                        alt={`Token ${item.tokenId}`}
                    />
                    <div className='nft-info'>
                        <div className='nft-text' style={{ marginBottom: '5px' }}>
                            Token ID:&nbsp;
                            <span
                                id={`token-id-tooltip-${index}`}
                                className={`${network.name}-text-color cursor-pointer`}
                                onClick={() => {
                                    setActiveTab('transfers')
                                    history.push(`/${network.name}/token/${address}?a=${item.tokenId}`)
                                }}
                            >
                                {item.tokenId}
                            </span>
                            <UncontrolledTooltip target={`token-id-tooltip-${index}`}>
                                {item.tokenId}
                            </UncontrolledTooltip>
                        </div>
                        <div className='nft-text'>
                            Owner:&nbsp;
                            <span
                                id={`owner-tooltip-${index}`}
                                className={`${network.name}-text-color cursor-pointer`}
                                onClick={() => {
                                    setActiveTab('transfers')
                                    history.push(`/${network.name}/token/${address}?a=${item.owner}`)
                                }}
                            >
                                {formatBytes(item.owner, 20, 9, 4)}
                            </span>
                            <UncontrolledTooltip target={`owner-tooltip-${index}`}>{item.owner}</UncontrolledTooltip>
                            &nbsp;
                            <CopyButton id={`copy-owner-${index}`} data={item.owner} text={'Copy Address'} />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

module.exports = { TokenInventoryTable }
